import { PropsWithChildren, useReducer } from 'react';
import { LogsContext, logsReducer, LogsReducerDefaultValues } from './LogsContext';
import { SharedContext, sharedReducer, SharedReducerDefaultValues } from './SharedContext';
import { AlarmsContext, alarmsReducer, AlarmsReducerDefaultValues } from './AlarmsContext';
import { GraphContext, graphReducer, GraphReducerDefaultValues } from './GraphContext';

export const ContextProviderComponent: React.FC<PropsWithChildren> = ({ children }) => {
  const [sharedState, sharedDispatch] = useReducer(sharedReducer, SharedReducerDefaultValues);

  const [graphState, graphDispatch] = useReducer(graphReducer, GraphReducerDefaultValues);

  const [logsState, logsDispatch] = useReducer(logsReducer, LogsReducerDefaultValues);

  const [alarmsState, alarmsDispatch] = useReducer(alarmsReducer, AlarmsReducerDefaultValues);

  return (
    <SharedContext.Provider value={{ state: sharedState, dispatch: sharedDispatch }}>
      <GraphContext.Provider value={{ state: graphState, dispatch: graphDispatch }}>
        <LogsContext.Provider value={{ state: logsState, dispatch: logsDispatch }}>
          <AlarmsContext.Provider value={{ state: alarmsState, dispatch: alarmsDispatch }}>
            {children}
          </AlarmsContext.Provider>
        </LogsContext.Provider>
      </GraphContext.Provider>
    </SharedContext.Provider>
  );
};
